(function () {
  async function add(root, items) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });

    if (!response.ok) return response;

    const cartResult = await response.clone().json().catch(function () { return null; });
    const addedItems = Array.isArray(cartResult && cartResult.items) ? cartResult.items : [];
    const eventItems = addedItems.map(function (item) {
      const quantity = Number(item.quantity || 1);
      const priceCents = Number(item.final_price != null ? item.final_price : item.price || 0);

      return {
        item_id: String(item.variant_id || item.id || ''),
        item_name: item.product_title || item.title || '',
        item_variant: item.variant_title || '',
        price: priceCents / 100,
        quantity: quantity
      };
    });
    const value = eventItems.reduce(function (total, item) {
      return total + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);

    const publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
    if (typeof publish === 'function') {
      await Promise.resolve(publish('framelune:add_to_cart', {
        currency: (window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        value: Number(value.toFixed(2)),
        items: eventItems
      })).catch(function () {});
    }

    return response;
  }

  window.FrameLuneCartEvents = { add };
})();
